module.exports = __webpack_public_path__ + "img/page_image_1_3.fe16d7fa.svg";